import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import HomePage from "../pages/home";

const PortfolioPage = lazy(() => import("../pages/portfolio"));
// const LeadershipPage = lazy(() => import("../pages/industry-leadership"));
const OurTeam = lazy(() => import("../pages/our-team"));
const ContactPage = lazy(() => import("../pages/contact-page"));
// const ArticleDetail = lazy(() => import("../pages/article-details"));
// const Investment = lazy(() => import("../pages/investment-thesis"));

export default function AppRoutes() {
  return (
    <Suspense fallback={<p className="p-6">Loading...</p>}>
      <Routes>
        <Route path="/" element={<HomePage lang="en" />} />
        <Route path="/ja/" element={<HomePage lang="ja" />} />
        <Route path="/portfolio" element={<PortfolioPage lang="en" />} />
        <Route path="/ja/portfolio" element={<PortfolioPage lang="ja" />} />
        {/* <Route path="/leadership" element={<LeadershipPage lang="en" />} />
        <Route path="/ja/leadership" element={<LeadershipPage lang="ja" />} /> */}
        <Route path="/our-team" element={<OurTeam lang="en" />} />
        <Route path="/ja/our-team" element={<OurTeam lang="ja" />} />
        <Route path="/contact" element={<ContactPage lang="en" />} />
        <Route path="/ja/contact" element={<ContactPage lang="ja" />} />
        {/* <Route path="/articles/:slug" element={<ArticleDetail lang="en" />} />
        <Route path="/ja/articles/:slug" element={<ArticleDetail lang="ja" />} />
        <Route path="/investment" element={<Investment lang="en" />} />
        <Route path="/ja/investment" element={<Investment lang="ja" />} /> */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}